module.exports = __webpack_public_path__ + "static/img/110_TO8_1808_og.4a0cd9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/110_TO8_1808_og.jpg
// module id = Ax1r
// module chunks = 0